import React, { useContext } from 'react';
import Sidebar from './components/Sidebar/Sidebar';
import CustomerSettingsField from './components/CustomerSettingsCheckbox/CustomerSettingsCheckbox';
import LanguageBar from './components/LanguageBar/LanguageBar';
import InputFields from './components/InputFields/InputFields';
import NoData from 'components/NoResultsFound/NoData';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './LocalizationTab.module.scss';

const LocalizationTab: React.FC = () => {
	const { localizationData, selectedLocalizationLanguage, restaurantForFullInfo } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container} data-test="LocalizationTab">
			{localizationData && restaurantForFullInfo ? (
				<>
					{localizationData.groups.length ? (
						<>
							<div className={style.sidebar}>
								<Sidebar items={localizationData.groups} />
							</div>
							<div className={style.content}>
								<div className={style.languageBar}>
									<LanguageBar items={restaurantForFullInfo.restaurantLanguages} />
								</div>
								<div className={style.customerSettings}>
									<CustomerSettingsField />
								</div>
								<div className={style.fields}>
									{restaurantForFullInfo.restaurantLanguages.map((el) => (
										<InputFields
											key={el.languageId}
											languageId={el.languageId}
											isVisible={selectedLocalizationLanguage?.id === el.languageId}
										/>
									))}
								</div>
							</div>
						</>
					) : (
						<NoData />
					)}
				</>
			) : null}
		</div>
	);
};

export default LocalizationTab;
